import React, { useState } from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { WebhookKeyWithPlain } from "../../types";
import {
  webhookKeyService,
  WebhookKeyCreateBody,
} from "../../services/webhookKeyService";
import WebhookKeyForm, { WebhookKeyFormData } from "./WebhookKeyForm";
import WebhookKeyRevealModal from "./WebhookKeyRevealModal";

function generatePartnerId(): string {
  // crypto-secure UUID v4 senza dash + prefisso "wk_"
  // Es: "wk_4b3e8e7ad9c64b7cbb2f9a3f5e2c1a8d" (35 char, <64 max BE)
  return `wk_${crypto.randomUUID().replace(/-/g, "")}`;
}

export default function WebhookKeyCreate() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const [revealKey, setRevealKey] = useState<WebhookKeyWithPlain | null>(null);

  const handleSubmit = async (data: WebhookKeyFormData) => {
    setIsLoading(true);
    setSubmitError(null);
    try {
      const body: WebhookKeyCreateBody = {
        partnerId: generatePartnerId(),
        partnerName: data.partnerName,
        scopes: data.scopes,
        allowedEventTypes:
          data.allowedEventTypes && data.allowedEventTypes.length > 0
            ? data.allowedEventTypes
            : undefined,
        notes: data.notes && data.notes.trim() !== "" ? data.notes : undefined,
      };
      const res = await webhookKeyService.create(body);
      setRevealKey(res.data.data);
    } catch (e) {
      console.error(e);
      setSubmitError("Errore durante la creazione della chiave");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRevealClose = () => {
    const created = revealKey;
    setRevealKey(null);
    if (created) navigate(`/egg/webhook-keys/${created.id}`);
  };

  return (
    <Box sx={{ maxWidth: 800, mx: "auto", py: 3 }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
        <Button
          size="small"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/egg/webhook-keys")}
        >
          Indietro
        </Button>
      </Stack>

      <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
        Nuova webhook key
      </Typography>

      <Paper sx={{ p: 3 }}>
        <WebhookKeyForm
          mode="create"
          onSubmit={handleSubmit}
          isLoading={isLoading}
          submitLabel="Crea chiave"
          submitError={submitError}
        />
      </Paper>

      <WebhookKeyRevealModal
        keyData={revealKey}
        context="created"
        onClose={handleRevealClose}
      />
    </Box>
  );
}
